import i18n from 'i18next';

import { TitleKeys } from 'pages/ParentHelper/components/History/components/Content/types';

export const getTitleData = (diffInDays: number, isFavorite = false) => {
  const conditions = [
    {
      check: () => isFavorite,
      title: 'pages.parentHelper.history.groupedTopicsTitles.favourites',
      titleKey: TitleKeys.Favorite,
    },
    {
      check: () => diffInDays === 0,
      title: 'pages.parentHelper.history.groupedTopicsTitles.today',
      titleKey: TitleKeys.Today,
    },
    {
      check: () => diffInDays === 1,
      title: 'pages.parentHelper.history.groupedTopicsTitles.yesterday',
      titleKey: TitleKeys.Yesterday,
    },
    {
      check: () => diffInDays <= 3,
      title: 'pages.parentHelper.history.groupedTopicsTitles.previous3Days',
      titleKey: TitleKeys.Previous3Days,
    },
    {
      check: () => diffInDays <= 7,
      title: 'pages.parentHelper.history.groupedTopicsTitles.previous7Days',
      titleKey: TitleKeys.Previous7Days,
    },
    {
      check: () => diffInDays <= 30,
      title: 'pages.parentHelper.history.groupedTopicsTitles.previous30Days',
      titleKey: TitleKeys.Previous30Days,
    },
  ];

  const { title, titleKey } = conditions.find(condition =>
    condition.check(),
  ) || {
    title: 'pages.parentHelper.history.groupedTopicsTitles.earlier',
    titleKey: TitleKeys.Earlier,
  };

  return { title: i18n.t(title), titleKey };
};
